import * as actionTypes from '../constants/ActionTypes';

/* ------------------------------------- */
// Init posts
/* ------------------------------------- */

export const initPosts = () => ({ type: actionTypes.INIT_POSTS });
